/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html, CSSResultArray, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from './nile-grid-head.css';
import NileElement from '../../internal/nile-element';

/**
 * Nile grid-head component.
 *
 * @tag nile-grid-head
 *
 */
@customElement('nile-grid-head')
export class NileGridHead extends NileElement {
  /**
   * The styles for nile-grid-head
   * @remarks If you are extending this class you can extend the base styles with super. Eg `return [super(), myCustomStyles]`
   */
  public static get styles(): CSSResultArray {
    return [styles];
  }

  @property({ type: Boolean, reflect: true, attribute: true }) sticky: boolean = false;

  /* #endregion */

  /* #region Methods */

  public render(): TemplateResult {
    return html`
      <div part="grid-head-base">
        <slot></slot>
      </div>
    `;
  }

  /* #endregion */
}

export default NileGridHead;

declare global {
  interface HTMLElementTagNameMap {
    'nile-grid-head': NileGridHead;
  }
}
